import view from './view.html';

/* @ngInject */
export default function () {
	return {
		replace:                    true,
		template:                   view,
		scope:                      {
			documentId: '=',
		},
		controller: /* @ngInject */ ($scope, DocumentsDocuments, STATUSES, $timeout) => {
			$scope.status = STATUSES.UNLOADED;

			$scope.refresh = () => {
				if ($scope.documentId) {
					$scope.status = STATUSES.LOADING;

					$timeout(() => {
						DocumentsDocuments.one($scope.documentId)
						                  .get({
							                  include: 'latestVersion',
						                  })
						                  .then((document) => {
							                  $scope.documentVersion = document.latestVersion;

							                  $scope.status = STATUSES.LOADED;
						                  })
						                  .catch((error) => {
							                  $scope.status = STATUSES.ERRORED;
						                  });
					}, 5000);
				}
			};

			$scope.$watch('documentId', (newValue) => {
				$timeout(() => {
					$scope.refresh();
				});
			});

			$scope.refresh();
		},
		link:                       (scope, element, attrs) => {

		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/documentPreviewDocument/index.js